/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';
import { AxiosInstance } from 'axios';

export interface ICustomerPortalServiceAgreements {
    getServiceAgreements(
        locationIds: number[] | undefined,
        statuses: AgreementStatus[] | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<ServiceAgreementsResult>;
    serviceAgreementsExist(
        statuses: AgreementStatus[] | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<boolean>;
    getServiceAgreement(
        agreementId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<ServiceAgreementInfo>;
    getCoveredLocationAddresses(
        agreementId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<AddressModel[]>;
    getVisits(
        agreementId: number,
        locationIds: number[] | undefined,
        status: VisitStatusCpoVersion | null | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<VisitsResult>;
    getVisit(
        agreementId: number,
        visitId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<VisitListItem>;
    getJobs(agreementId: number, cancelToken?: CancelToken): AxiosPromise<JobsResult>;
    getJob(
        agreementId: number,
        jobId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<JobListItem>;
    getUnscheduledVisits(
        agreementId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<VisitsResult>;
    getVisitInvoices(
        agreementId: number,
        visitId: number,
        locationIds: number[] | undefined,
        status: VisitStatusCpoVersion | null | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<IPaginatedResultOfInvoiceListItem>;
    getInvoices(
        agreementId: number,
        locationIds: number[] | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<IPaginatedResultOfInvoiceListItem>;
    getEquipment(
        agreementId: number,
        serialNumber: string | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<EquipmentResult>;
    getEquipmentServiceHistory(
        agreementId: number,
        equipmentIdPath: number,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<EquipmentServiceHistoryResult>;
    getPdfDocument(agreementId: number, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    getESignUrl(agreementId: number, cancelToken?: CancelToken): AxiosPromise<string>;
}

export const BASE_URL_TOKEN_CustomerPortalServiceAgreements = symbolToken<string>(
    'BASE_URL_TOKEN',
    false
);

@injectable()
export class CustomerPortalServiceAgreements implements ICustomerPortalServiceAgreements {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
        private readonly axios: AxiosInstance,
        @inject(BASE_URL_TOKEN_CustomerPortalServiceAgreements)
        @optional()
        private readonly baseUrl = ''
    ) {}

    getServiceAgreements(
        locationIds: number[] | undefined,
        statuses: AgreementStatus[] | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<ServiceAgreementsResult> {
        let url_ = '/v1/customerportal/service-agreements?';
        if (locationIds === null) throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined)
            locationIds &&
                locationIds.forEach(item => {
                    url_ += 'locationIds=' + encodeURIComponent('' + item) + '&';
                });
        if (statuses === null) throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses &&
                statuses.forEach(item => {
                    url_ += 'statuses=' + encodeURIComponent('' + item) + '&';
                });
        if (page === null) throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (includeTotal === null) throw new Error("The parameter 'includeTotal' cannot be null.");
        else if (includeTotal !== undefined)
            url_ += 'includeTotal=' + encodeURIComponent('' + includeTotal) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<ServiceAgreementsResult>(options_));
    }

    getServiceAgreement(
        agreementId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<ServiceAgreementInfo> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<ServiceAgreementInfo>(options_));
    }

    getCoveredLocationAddresses(
        agreementId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<AddressModel[]> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/covered-location-addresses';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<AddressModel[]>(options_));
    }

    getVisits(
        agreementId: number,
        locationIds: number[] | undefined,
        status: VisitStatusCpoVersion | null | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<VisitsResult> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/visits?';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        if (locationIds === null) throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined)
            locationIds &&
                locationIds.forEach(item => {
                    url_ += 'locationIds=' + encodeURIComponent('' + item) + '&';
                });
        if (status !== undefined && status !== null)
            url_ += 'status=' + encodeURIComponent('' + status) + '&';
        if (page === null) throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (includeTotal === null) throw new Error("The parameter 'includeTotal' cannot be null.");
        else if (includeTotal !== undefined)
            url_ += 'includeTotal=' + encodeURIComponent('' + includeTotal) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<VisitsResult>(options_));
    }

    getVisit(
        agreementId: number,
        visitId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<VisitListItem> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/visits/{visitId}';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        if (visitId === undefined || visitId === null)
            throw new Error("The parameter 'visitId' must be defined.");
        url_ = url_.replace('{visitId}', encodeURIComponent('' + visitId));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<VisitListItem>(options_));
    }

    getJobs(agreementId: number, cancelToken?: CancelToken): AxiosPromise<JobsResult> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/jobs';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<JobsResult>(options_));
    }

    getJob(
        agreementId: number,
        jobId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<JobListItem> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/jobs/{jobId}';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace('{jobId}', encodeURIComponent('' + jobId));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<JobListItem>(options_));
    }

    getUnscheduledVisits(
        agreementId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<VisitsResult> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/unscheduledvisits';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<VisitsResult>(options_));
    }

    getVisitInvoices(
        agreementId: number,
        visitId: number,
        locationIds: number[] | undefined,
        status: VisitStatusCpoVersion | null | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<IPaginatedResultOfInvoiceListItem> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/visits/{visitId}/invoices?';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        if (visitId === undefined || visitId === null)
            throw new Error("The parameter 'visitId' must be defined.");
        url_ = url_.replace('{visitId}', encodeURIComponent('' + visitId));
        if (locationIds === null) throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined)
            locationIds &&
                locationIds.forEach(item => {
                    url_ += 'locationIds=' + encodeURIComponent('' + item) + '&';
                });
        if (status !== undefined && status !== null)
            url_ += 'status=' + encodeURIComponent('' + status) + '&';
        if (page === null) throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (includeTotal === null) throw new Error("The parameter 'includeTotal' cannot be null.");
        else if (includeTotal !== undefined)
            url_ += 'includeTotal=' + encodeURIComponent('' + includeTotal) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<IPaginatedResultOfInvoiceListItem>(options_));
    }

    getInvoices(
        agreementId: number,
        locationIds: number[] | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<IPaginatedResultOfInvoiceListItem> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/invoices?';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        if (locationIds === null) throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined)
            locationIds &&
                locationIds.forEach(item => {
                    url_ += 'locationIds=' + encodeURIComponent('' + item) + '&';
                });
        if (page === null) throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (includeTotal === null) throw new Error("The parameter 'includeTotal' cannot be null.");
        else if (includeTotal !== undefined)
            url_ += 'includeTotal=' + encodeURIComponent('' + includeTotal) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<IPaginatedResultOfInvoiceListItem>(options_));
    }

    getEquipment(
        agreementId: number,
        serialNumber: string | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<EquipmentResult> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/equipment?';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        if (serialNumber === null) throw new Error("The parameter 'serialNumber' cannot be null.");
        else if (serialNumber !== undefined)
            url_ += 'serialNumber=' + encodeURIComponent('' + serialNumber) + '&';
        if (page === null) throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (includeTotal === null) throw new Error("The parameter 'includeTotal' cannot be null.");
        else if (includeTotal !== undefined)
            url_ += 'includeTotal=' + encodeURIComponent('' + includeTotal) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<EquipmentResult>(options_));
    }

    serviceAgreementsExist(
        statuses: AgreementStatus[] | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<boolean> {
        let url_ = '/v1/customerportal/service-agreements/exists?';
        if (statuses === null) throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses &&
                statuses.forEach(item => {
                    url_ += 'statuses=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<boolean>(options_));
    }

    getEquipmentServiceHistory(
        agreementId: number,
        equipmentIdPath: number,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<EquipmentServiceHistoryResult> {
        let url_ =
            '/v1/customerportal/service-agreements/{agreementId}/equipment/{equipmentId}/service-history?';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        if (equipmentIdPath === undefined || equipmentIdPath === null)
            throw new Error("The parameter 'equipmentIdPath' must be defined.");
        url_ = url_.replace('{equipmentId}', encodeURIComponent('' + equipmentIdPath));
        if (page === null) throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (includeTotal === null) throw new Error("The parameter 'includeTotal' cannot be null.");
        else if (includeTotal !== undefined)
            url_ += 'includeTotal=' + encodeURIComponent('' + includeTotal) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<EquipmentServiceHistoryResult>(options_));
    }

    getPdfDocument(agreementId: number, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/pdf';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    getESignUrl(agreementId: number, cancelToken?: CancelToken): AxiosPromise<string> {
        let url_ = '/v1/customerportal/service-agreements/{agreementId}/esign-url';
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace('{agreementId}', encodeURIComponent('' + agreementId));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<string>(options_));
    }
}

export interface ServiceAgreementsResult {
    page: number;
    pageSize: number;
    hasMore: boolean;
    totalCount?: number | undefined;
    data?: ServiceAgreementListItem[] | undefined;
    unfilteredTotalCount: number;
}

export interface ServiceAgreementListItem {
    id: number;
    name?: string | undefined;
    status: AgreementStatus;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    locationsCount: number;
    autoRenew: boolean;
    endingSoon: boolean;
    eSignStatus: ESignStatus | undefined;
}

export enum AgreementStatus {
    Draft = 0,
    Sent = 1,
    Rejected = 2,
    Accepted = 3,
    Activated = 4,
    Canceled = 5,
    Expired = 6,
    Hold = 7,
    AutoRenew = 8,
}

export enum ESignStatus {
    NotRequired = 0,
    Required = 1,
    Signed = 2,
}

export interface ServiceAgreementInfo {
    id: number;
    name?: string | undefined;
    status?: AgreementStatus | undefined;
    customerName?: string | undefined;
    accountManagerName?: string | undefined;
    coverageStartDate?: Date | undefined;
    coverageEndDate?: Date | undefined;
    billingScheduleType?: BillingScheduleType | undefined;
    recurringBillingAmount?: number | undefined;
    locationsCount: number;
    remainingVisitsCount: number;
    nextVisitStartDate?: Date | undefined;
    nextVisitEndDate?: Date | undefined;
    nextVisitStatus?: VisitStatus | undefined;
    remainingBalance: number;
    amountBilled: number;
    nextBillingDate?: Date | undefined;
    eSignStatus: ESignStatus | undefined;
}

export enum BillingScheduleType {
    Upfront = 0,
    Monthly = 1,
    EveryOtherMonth = 2,
    Quarterly = 3,
    Biannual = 6,
    Annual = 12,
    TimeOfService = 100,
}

export enum VisitStatus {
    Unscheduled = 0,
    JobBooked = 3,
    Dismissed = 4,
}

export interface AddressModel {
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    unit?: string | undefined;
}

export interface VisitsResult {
    page: number;
    pageSize: number;
    hasMore: boolean;
    totalCount?: number | undefined;
    data?: VisitListItem[] | undefined;
    unfilteredTotalCount: number;
}

export interface VisitListItem {
    id: number;
    name?: string | undefined;
    jobTypeName?: string | undefined;
    startDate: Date;
    endDate: Date;
    locationAddress?: AddressModel | undefined;
    location?: LocationModel | undefined;
    serviceAgreementName?: string | undefined;
    status: VisitStatusCpoVersion;
}

export interface LocationModel {
    id: number;
    name: string;
    address?: AddressModel | undefined;
}

/** Customer Portal's mapped version of VisitProgressStatus */
export enum VisitStatusCpoVersion {
    Upcoming = 0,
    Completed = 1,
    Canceled = 2,
}

export interface IPaginatedResultOfInvoiceListItem {
    page: number;
    pageSize: number;
    hasMore: boolean;
    totalCount?: number | undefined;
    data: InvoiceListItem[];
}

export interface InvoiceListItem {
    invoiceIdentifier?: InvoiceIdentifier | undefined;
    dueDate?: Date | undefined;
    amount: number;
    balance: number;
    serviceAddress?: string | undefined;
    paymentMethods?: string[] | undefined;
}

export interface InvoiceIdentifier {
    id?: string | undefined;
    number?: string | undefined;
}

export interface EquipmentResult {
    page: number;
    pageSize: number;
    hasMore: boolean;
    totalCount?: number | undefined;
    data?: EquipmentListItem[] | undefined;
}

export interface EquipmentListItem {
    equipmentId: number;
    image?: string | undefined;
    name?: string | undefined;
    manufacturer?: string | undefined;
    model?: string | undefined;
    serialNumber?: string | undefined;
    installDate?: Date | undefined;
    manufacturerWarrantyStartDate?: Date | undefined;
    manufacturerWarrantyEndDate?: Date | undefined;
    serviceProviderWarrantyStartDate?: Date | undefined;
    serviceProviderWarrantyEndDate?: Date | undefined;
}

export interface EquipmentServiceHistoryResult {
    page: number;
    pageSize: number;
    hasMore: boolean;
    totalCount?: number | undefined;
    data?: EquipmentServiceHistoryItem[] | undefined;
}

export interface EquipmentServiceHistoryItem {
    maintenanceVisitName?: string | undefined;
    visitDate: Date;
    technicians?: TechnicianModel[] | undefined;
    invoiceIdentifier?: InvoiceIdentifier | undefined;
    invoiceSummary?: string | undefined;
}

export interface TechnicianModel {
    id: number;
    name?: string | undefined;
    photo?: string | undefined;
}

export interface JobsResult {
    page: number;
    pageSize: number;
    hasMore: boolean;
    totalCount?: number | undefined;
    data?: JobListItem[] | undefined;
    unfilteredTotalCount: number;
}

export interface JobListItem {
    id: number;
    number?: string | undefined;
    type?: string | undefined;
    status: JobListItemStatus;
    appointmentCount: number;
    firstNotCompletedAppointmentStartDate?: Date | undefined;
    firstNotCompletedAppointmentEndDate?: Date | undefined;
    lastAppointmentStartDate?: Date | undefined;
    lastAppointmentEndDate?: Date | undefined;
    serviceAgreementId?: number | undefined;
    serviceAgreementName?: string | undefined;
    proposalId?: number | undefined;
    proposalName?: string | undefined;
    invoiceId?: number | undefined;
    serviceLocation?: LocationModel | undefined;
}

export enum JobListItemStatus {
    Scheduled = 0,
    InProgress = 2,
    OnHold = 3,
    Completed = 4,
    Canceled = 5,
}

export interface LocationModel {
    id: number;
    name: string;
    address?: AddressModel | undefined;
}

export type FileResponse = Blob;
